import { render, staticRenderFns } from "./insertLectureDialog.vue?vue&type=template&id=077f1361&scoped=true&"
import script from "./insertLectureDialog.vue?vue&type=script&lang=js&"
export * from "./insertLectureDialog.vue?vue&type=script&lang=js&"
import style0 from "./insertLectureDialog.vue?vue&type=style&index=0&id=077f1361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f1361",
  null
  
)

export default component.exports